import script from "./workBench.vue?vue&type=script&setup=true&lang=ts"
export * from "./workBench.vue?vue&type=script&setup=true&lang=ts"

import "./workBench.vue?vue&type=style&index=0&id=55a95bfd&lang=scss&scoped=true"

import exportComponent from "E:\\云工厂标准版\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55a95bfd"]])

export default __exports__